import axios from 'axios';

export default {
    get() {
        var options = {
            method:'GET',
            url: window.apiUrl + '/checkins',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response.data;        
        }).catch((e) =>{
            console.log(e);
            throw new Error(e);
        })
    },
    create(checkin) {
        var options = {
            method:'POST',
            url: window.apiUrl + '/checkin',
            data: checkin,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response.data;        
        }).catch((e) =>{
            console.log(e);
            throw new Error(e);
        })
    },
    submitFeedback(feedback) {
        var options = {
            method:'POST',
            url: window.apiUrl + '/checkin-feedback',
            data: feedback,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response.data;        
        }).catch((e) =>{
            console.log(e);
            throw new Error(e);
        })
    },
    submitEvaluation(evaluation) {
        var options = {
            method:'POST',
            url: window.apiUrl + '/weekly-evaluation',
            data: evaluation,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response.data;        
        }).catch((e) =>{
            console.log(e);
            throw new Error(e);
        })
    },
}


// WEBPACK FOOTER //
// ./src/services/checkins/index.js